<template>
  <v-container>
    <h2>EVENTOS PADRE</h2>
    <CRUDIndex :permissionRoot="'Torneos'" :headers="headers" :storeModel="storeModel"
      :storeModelPlural="storeModelPlural" />
  </v-container>
</template>

<script>
import CRUDIndex from '../globals/CRUDIndex'
export default {
  components: {
    CRUDIndex
  },
  data() {
    return {
      headers: [
        { text: 'Nombre', value: 'name' },
      ],
      storeModel: 'ParentEvent',
      storeModelPlural: 'ParentEvents',
    }
  }
}
</script>

<style></style>e
